import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlusSquare, faTimes} from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import api from '../../../shared/utils/auth/Index';
import {Spinner} from "react-bootstrap";
import Select from "react-select";
import AttributeValue from "../../Category/Partials/AttributeValue";

const Attributes = ({formData, setFormData}) => {

    const [categories, setCategories] = useState(undefined);
    const [colors, setColors] = useState([]);
    useEffect(() => {
        fetchCategories();
    }, []);

    const  fetchCategories = () => {
      let url = '/categories-all-with-relations';
      api.get(url, {}, (res) => {
          let data = res.data;
          setCategories(data.data);
          setColors(data.colors)

      }, (err) => {
          alert('error')
      });
    }

    const getCategories = () => {
        return categories;
    }

    const getOptions = () => {
        let categories = getCategories();
        return categories.map((category) => ({value: category.id, label: category.name}) );

    }

    const onChangeCategory = (selectedOption) => {
        let newProductAttributes = getNewProductAttributes(selectedOption.value);
        setFormData({...formData, category_id: selectedOption.value, product_attributes: newProductAttributes});
    }

    const getNewProductAttributes = (categoryId) => {
        let category = categories.find((item) => item.id === categoryId);
        let attributes = category.attributes;
        let emptyProductAttributes = attributes.map((item) => ({attribute_id: item.id}));

        return emptyProductAttributes;
    }

    const getCategoryAsOption = () => {
        if (!formData.category_id) {
            return null;
        }

        let category = categories.find((item) => item.id === formData.category_id);
        return {value: category.id, label: category.name};
    }

    const getAttributes = () => {
        let category = categories.find((item) => item.id === formData.category_id);
        return category.attributes;
    }

    const onAddPriceOption = (attributeId) =>  {
        setFormData({...formData, product_attributes:
                [...formData.product_attributes, {attribute_id: attributeId}] });
    }

    const onRemovePriceOption = (attributeId, priceOptionIndex) => {
        let priceOptions = getPriceOptionValue(attributeId);
        let priceOption = priceOptions[priceOptionIndex];

        setFormData({...formData, product_attributes:
                formData.product_attributes.filter((item) => item !== priceOption) });
    }

    const getAttributeValue = (attributeId) => {
        let item = formData.product_attributes.find((item) => item.attribute_id === attributeId );
        if (item) {
            return item.val;
        }
    }

    const getPriceOptionValue = (attributeId) => {
        let items = formData.product_attributes.filter((item) => item.attribute_id === attributeId );
        return items;
    }

    const onChangeProductAttribute = (attributeId, object, priceOptionIndex) => {

        if (priceOptionIndex === undefined) {
            setFormData({...formData, product_attributes:
                    formData.product_attributes.map((item) => item.attribute_id === attributeId ?
                        {...item, ...object} : item) });
        } else {
            let priceOptions = getPriceOptionValue(attributeId);
            let priceOption = priceOptions[priceOptionIndex];

            setFormData({...formData, product_attributes:
                    formData.product_attributes.map((item) => item === priceOption ? {...item, ...object} : item) });
        }
    }

    if (categories === undefined)  return <Spinner animation="border" />;

    return (
        <>
            <div className="font-irs-b mb-3">
                تعریف ویژگی
            </div>
            <div className="row">
                <div className="col-3">
                    <div className="col-auto">
                        <label>دسته بندی</label>
                        <Select options={getOptions()}
                                value={getCategoryAsOption()}
                                onChange={onChangeCategory}
                        />
                    </div>
                </div>
            </div>

            {formData.category_id &&
                getAttributes().map((attribute, attributeIndex) => (
                    <div key={attribute.id} className="row align-items-center mt-4">
                        <div className="col-auto font-irs-b">
                            <span className="d-inline-block product-attr-name">{attribute.name}

                                {attribute.effect_on_price === 1 &&
                                <span className="text-success d-inline-block pr-1"
                                      onClick={() => onAddPriceOption(attribute.id)}>
                                    <FontAwesomeIcon icon={faPlusSquare} size="lg"/>
                                </span>
                                }
                            </span>

                        </div>
                        {attribute.effect_on_price === 1  ? (
                            <div className="col">
                                { getPriceOptionValue(attribute.id).map((priceOption, index) => (
                                        <>
                                            <div className="row align-items-center">
                                                <div className="col-auto">
                                                    <label>مقدار/مقادیر</label>
                                                    <AttributeValue attribute={attribute} colors={colors}
                                                                    value={priceOption.val}
                                                                    priceOptionIndex={index}
                                                                    onChangeProductAttribute={onChangeProductAttribute}/>
                                                </div>

                                                <div className="col-auto">
                                                    <label>تعداد</label>
                                                    <input type="number" step="1" className="form-control"
                                                           value={priceOption.capacity}
                                                           onChange={(e) =>
                                                               onChangeProductAttribute(attribute.id, {capacity: e.target.value}, index)}
                                                    />
                                                </div>
                                                <div className="col-auto">
                                                    <label>قیمت(تومان)</label>
                                                    <input type="number" step="1" className="form-control" required min={1}
                                                           value={priceOption.price}
                                                           onChange={(e) =>
                                                               onChangeProductAttribute(attribute.id, {price: e.target.value}, index)}
                                                           />
                                                </div>
                                                <div className="col-auto">
                                                    <br />
                                                    <span className="text-danger"
                                                    onClick={() => onRemovePriceOption(attribute.id, index)}>
                                                        <FontAwesomeIcon icon={faTimes} size="lg"/>
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    )
                                )}
                            </div>
                        ) : (
                            <div className="col-auto">
                                <label>مقدار/مقادیر</label>
                                <AttributeValue attribute={attribute} colors={colors}
                                                value={getAttributeValue(attribute.id)}
                                                onChangeProductAttribute={onChangeProductAttribute}/>
                            </div>
                            )
                        }
                    </div>
                ))
            }

        </>
    )
}

export default Attributes;
